import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateService } from "@ngx-translate/core";

@Component({
    selector: 'app-file-card',
    templateUrl: './file-card.component.html',
    styleUrls: ['./file-card.component.scss']
})
export class FileCardComponent implements OnInit {

    @Input() icon = 'fa-file';
    @Input() title = '';
    @Input() pdfUrl = '';
    @Input() docUrl = ''
    @Output() select = new EventEmitter<any>();
    @Output() remove = new EventEmitter<any>();

    constructor(private translate: TranslateService) {
    }

    ngOnInit(): void {
    }

    doSelect(type: string, url: string) {
        this.select.emit({type, url})
    }

    doRemove() {
        this.remove.emit();
    }
}
